var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center"},[_c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(this.hovered.id))]),_c('span',{staticClass:"flex items-center"},[_c('RadarIcon',{staticClass:"w-4 mr-1"}),_vm._v(" "+_vm._s(this.flights)+" ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }